import Vue from 'vue';
import { localObjectStorage } from '@/libs/localstorage';

const LAST_READ_KEY = 'announcement_last_read';

const state = Vue.observable({
  lastUpdated: null,
  lastRead: localObjectStorage.load(LAST_READ_KEY),
});

export const announcement = {
  get lastUpdated() {
    return state.lastUpdated;
  },
  get lastRead() {
    return state.lastRead;
  },
  get hasUnread() {
    if (!state.lastUpdated) return false;
    if (!state.lastRead) return true;
    return state.lastUpdated > state.lastRead;
  },

  setLastUpdated(value) {
    state.lastUpdated = value;
  },
  markAsRead() {
    state.lastRead = new Date().toISOString();
    localObjectStorage.store(LAST_READ_KEY, state.lastRead);
  },
};
